import { ReactNode } from 'react';
import { Card, Stack, Text, styled, DarkTooltip, Icons } from '@/theme/index';

interface ReportSectionProps {
  children?: ReactNode;
  title: string;
  reportId?: string;
}

const StyledInsightsText = styled(Text)(({ theme }) => ({
  fontSize: theme.typography.caption.fontSize,
  display: 'none',
  [theme.breakpoints.up('sm')]: {
    display: 'block',
  },
}));

export function ObituaryReportContainer({
  children,
  title,
  reportId,
}: ReportSectionProps) {
  return (
    <Card sx={{ boxShadow: 'none' }} id={reportId}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Text variant="h2" data-cy="report-section-title-text" m={0}>
          {title}
        </Text>
        <Stack direction="row" alignItems="center">
          <Stack
            bgcolor="black"
            sx={{ borderRadius: '100%' }}
            height={18}
            width={18}
            mr={0.5}
          >
            <DarkTooltip
              arrow
              enterTouchDelay={0}
              leaveTouchDelay={2000}
              disableHoverListener
              title="Smart Insight"
            >
              <Icons.AutoAwesome
                sx={{
                  height: '12px',
                  width: '12px',
                  fill: 'white',
                  margin: 'auto',
                }}
              />
            </DarkTooltip>
          </Stack>
          <StyledInsightsText typography="primary">
            Smart Insight
          </StyledInsightsText>
        </Stack>
      </Stack>
      {children}
    </Card>
  );
}
